// extracted by mini-css-extract-plugin
export default {"ListContainer":"styles_ListContainer__OHGTx","livdomMention":"styles_livdomMention__WlEDY","warningSign":"styles_warningSign__2bkFM","livdomCost":"styles_livdomCost__4cXiv"};